
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { uploadFile } from '@/helpers/CmsIndexHelper';
import { UploadFile } from 'ant-design-vue/types/upload';
import { PdfImageOverride, PdfImageOverrideConfig } from '@/modules/CMS/interfaces/PdfImageOverride';

@Component({
    name: 'PdfImageOverridesInput',
})
export default class PdfImageOverridesInput extends Vue {
    @Prop({ required: true }) private value!: PdfImageOverride[];
    @Prop({ default: false }) private isDisabled!: boolean;
    @Prop({ required: true }) private selectedLocale!: string | null;

    private localOverrides: PdfImageOverride[] = [];
    private configExample = '{"p2067":"RONDO"}';

    private mounted() {
        this.localOverrides = this.value && this.value.length > 0 ? JSON.parse(JSON.stringify(this.value)) : [];
    }

    private onAddOverride() {
        this.localOverrides.push({
            image: [],
            config: {},
            configString: '',
        });
        this.emitChanges();
    }

    private onRemoveOverride(index: number) {
        this.$confirm({
            title: this.$t('Jeste li sigurni da želite obrisati?') as string,
            content: '',
            okText: this.$t('Da') as string,
            okType: 'danger',
            cancelText: this.$t('Ne') as string,
            onOk: () => {
                this.localOverrides.splice(index, 1);
                this.emitChanges();
            },
        });
    }

    private onRemoveImage(index: number) {
        this.localOverrides[index].image = [];
        this.emitChanges();
    }

    private async onCustomRequest({ file, onSuccess, onError }: any, index: number) {
        try {
            const uploadedFile = await uploadFile(file, 'image', undefined, undefined, this.selectedLocale);
            this.localOverrides[index].image = [
                {
                    uid: uploadedFile.data.id,
                    name: file.name,
                    url: uploadedFile.data.image,
                    status: 'done',
                    size: file.size || 0,
                    type: file.type || '',
                },
            ] as UploadFile[];
            this.emitChanges();
            onSuccess();
        } catch (e) {
            this.$notification.error({
                message: this.$t('Error') as string,
                description: this.$t('Could not upload image') as string,
            });
            onError(e);
        }
    }

    private onConfigChange(index: number) {
        const configString = this.localOverrides[index].configString.trim();

        if (!configString) {
            this.localOverrides[index].config = {};
            this.localOverrides[index].configError = undefined;
            this.emitChanges();
            return;
        }

        try {
            const parsed = JSON.parse(configString);
            if (
                parsed === null ||
                Array.isArray(parsed) ||
                typeof parsed !== 'object' ||
                Object.keys(parsed).length === 0
            ) {
                throw new Error();
            }
            this.localOverrides[index].config = parsed as PdfImageOverrideConfig;
            this.localOverrides[index].configError = undefined;
        } catch (e) {
            this.localOverrides[index].configError = this.$t('Enter a non-empty JSON object.') as string;
            this.localOverrides[index].config = {};
        }

        this.emitChanges();
    }

    private emitChanges() {
        this.$emit('input', this.localOverrides);
        this.$emit('change', this.localOverrides);
    }

    @Watch('value', { deep: true })
    private onValueChange(newValue: PdfImageOverride[]) {
        if (JSON.stringify(newValue) !== JSON.stringify(this.localOverrides)) {
            this.localOverrides = newValue && newValue.length > 0 ? JSON.parse(JSON.stringify(newValue)) : [];
        }
    }
}
